
import { baseUrl } from "../../constants";
import { 
    getDDDeptCall, getDDAreaCall, getDDCompCall, getDDLocCall  
} from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

export default {
    "formTitle": "Add Plan / Facility",
    "tableTitle": "Plan / Facility List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [
                getDDCompCall, //getDDDeptCall, getDDAreaCall, getDDLocCall 
            ];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/facility/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/facility`,
        edit: `${baseUrl}/api/mms/facility/edit`,
        delete: `${baseUrl}/api/mms/facility/remove`
    },
    "tableCol": [
        {
            name: 'Company',
            selector: row => row.comp_id,
            sortable: true
        },
        {
            name: 'Location',
            selector: row => row.loc_id,
            sortable: true
        },
        {
            name: 'Department',
            selector: row => row.department_id,
            sortable: true
        },
        {
            name: 'Area',
            selector: row => row.area_id,
            sortable: true
        },
        {
            name: 'Facility',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'select',
                    label: 'Company',
                    name: 'comp_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Location',
                    name: 'loc_id',
                    "options": []
                },
                {
                    type: 'select',
                    label: 'Department',
                    name: 'department_id',
                    "options": [],
                    // "required": true
                },
                {
                    type: 'select',
                    label: 'Area',
                    name: 'area_id',
                    "options": [],
                    // "required": true
                },
                {
                    type: 'text',
                    label: 'Facility',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "department": 1,
        "area": 1,
        "facility": "safds"
    }]
}